import countBy from 'lodash/countBy';
import { fetchList } from '@/api/account';

export const state = {
	accounts: [],
};

export const mutations = {
	SET_ACCOUNT_LIST(state, value) {
		state.accounts = value;
	},
};

export const getters = {
	accounts(state, getter, rootState) {
		return state.accounts.filter(account => {
			return rootState.assets.assets.find(asset => {
				return account.asset_seq === asset.seq;
			});
		});
		// return state.accounts; //tmp
	},
	own_assets_group(state) {
		let data = [];
		data = countBy(state.accounts, 'asset_seq');

		return data;
	},
};

export const actions = {
	init({ dispatch, rootGetters }) {
		if (!rootGetters['auth/is_logged_in']) return;
		dispatch('getAccounts');
	},
	async getAccounts({ commit }) {
		const { data } = await fetchList({
			no_paging: 1,
			is_master: 'Y',
		});
		commit('SET_ACCOUNT_LIST', data);
		return data;
	},
};
